module.exports = __webpack_public_path__ + "img/Platform.199801e6.svg";